export enum TypeOfTravelSimEnum {
  inbound,
  outbound,
}
